var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-gauge-chart"},[_c('ve-gauge',{attrs:{"data":_vm.chartData,"settings":_vm.chartSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }